module.exports = __webpack_public_path__ + "img/kaiquicon3.647cd647.png";